import { Link } from "react-router-dom";
import { Library, ArrowRight } from "lucide-react";
import { BOOKS, BUNDLE } from "@/lib/catalog";

export default function BundleSavingsNote() {
  const savings = BOOKS.reduce((sum, b) => sum + b.price, 0) - BUNDLE.price;
  return (
    <Link
      to={`/books/${BUNDLE.id}`}
      data-testid="bundle-savings-note"
      className="group mt-6 flex items-center gap-4 border border-primary-gold/30 bg-primary-gold/5 px-4 py-4 hover:bg-primary-gold/10 transition-colors"
    >
      <Library className="w-5 h-5 text-primary-gold shrink-0" />
      <div className="flex-1">
        <p className="text-sm text-text-primary">
          Save <span className="text-primary-gold font-semibold">${savings.toFixed(2)}</span> with the Complete Collection
        </p>
        <p className="text-xs text-soft mt-0.5">
          All four novels for ${BUNDLE.price.toFixed(2)}
        </p>
      </div>
      <ArrowRight className="w-4 h-4 text-primary-gold transition-transform group-hover:translate-x-1" />
    </Link>
  );
}
